module.exports = __webpack_public_path__ + "static/media/CHAP00-CLAVIER.dfeca8d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP00-CLAVIER.png
// module id = 244
// module chunks = 0